"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7873],{

/***/ 67873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HomeMobile; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(92833);
/* harmony import */ var _components_HotelsTonight_HotelsTonight__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63617);
/* harmony import */ var _components_PromoFeatureBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85330);
/* harmony import */ var _components_Hotels_SearchForm_Form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48935);
/* harmony import */ var _components_ConditionalRender__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60801);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1377);
/* harmony import */ var _components_Hotels_SearchForm_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50309);
/* harmony import */ var _components_StyledHeading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5527);
/* harmony import */ var _components_MobileHeaderWrapper_MobileHeaderWrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75035);
/* harmony import */ var _hooks_useMostRecentFutureBooking__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9494);
/* harmony import */ var _components_CrossSell__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64296);
/* harmony import */ var _components_EmailSignUp__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(72365);
/* harmony import */ var _constants_content__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66466);
/* harmony import */ var _hooks_useSEMSearchHeadline__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17057);
/* harmony import */ var _components_Promos_MarketingTout_MarketingTout__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(97207);
/* harmony import */ var _hooks_useCityNameInFormHeadlineForSEM__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97418);
/* harmony import */ var _hooks_useContentfulSearchFormHeadlines__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(34752);
/* harmony import */ var _hooks_useExtendStayBooking__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(37344);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





















var PRIMARY_HEADING_FALLBACK = 'Find your next hotel deal';
var SECONDARY_HEADING_FALLBACK = 'Save with exclusive rates';
var ExtendStayV3 = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_2__["default"])(function() {
    return __webpack_require__.e(/* import() */ 8155).then(__webpack_require__.bind(__webpack_require__, 28155));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28155)
            ];
        }
    }
});
function HomeMobile() {
    var mostRecentFutureBooking = (0,_hooks_useMostRecentFutureBooking__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z), _signInStatus = ref.signInStatus, signedIn = _signInStatus.signedIn, passiveSignIn = _signInStatus.passiveSignIn, firstName = ref.customer.firstName;
    var extendData = (0,_hooks_useExtendStayBooking__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)();
    var isSignedIn = signedIn || passiveSignIn;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), location = ref1[0], setLocation = ref1[1];
    var prePopHeadline = (0,_hooks_useCityNameInFormHeadlineForSEM__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(location);
    var SEMHeadline = (0,_hooks_useSEMSearchHeadline__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
    var form = (0,_hooks_useContentfulSearchFormHeadlines__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)('searchFormHotels');
    /**
   * TODO: Add these values to contentful
   */ var headlineVIP = firstName ? _constants_content__WEBPACK_IMPORTED_MODULE_14__/* ["default"].homepage.vip.headlineWithName.replace */ .ZP.homepage.vip.headlineWithName.replace('{firstName}', firstName) : _constants_content__WEBPACK_IMPORTED_MODULE_14__/* ["default"].homepage.vip.defaultHeading */ .ZP.homepage.vip.defaultHeading;
    var subheadline = {
        text: isSignedIn ? _constants_content__WEBPACK_IMPORTED_MODULE_14__/* ["default"].homepage.hotel.signedInSubHeading */ .ZP.homepage.hotel.signedInSubHeading : (form === null || form === void 0 ? void 0 : form.mobileSubheadline) || SECONDARY_HEADING_FALLBACK
    };
    var headlineValues = {
        text: isSignedIn ? headlineVIP : prePopHeadline || SEMHeadline || (form === null || form === void 0 ? void 0 : form.mobileHeadline) || PRIMARY_HEADING_FALLBACK
    };
    var CrossSellContent = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: mostRecentFutureBooking ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CrossSell__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                booking: mostRecentFutureBooking
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PromoFeatureBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MobileHeaderWrapper_MobileHeaderWrapper__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                selectedProductName: "Hotels",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                    px: 3,
                    mt: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                            flexDirection: "column",
                            mb: 3,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread({}, headlineValues, {
                                    tag: "h1",
                                    color: "text.heading",
                                    textStyle: "heading3"
                                })),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, _objectSpread({
                                    color: "text.light",
                                    mt: 1,
                                    textStyle: "subheading6"
                                }, subheadline, {
                                    tag: "h2"
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Hotels_SearchForm_Form__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            onSubmit: _components_Hotels_SearchForm_utils__WEBPACK_IMPORTED_MODULE_8__/* .handleSubmitForHotels */ .Ky,
                            setLocation: setLocation
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalRender__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                experimentCode: "HP_MBL_HOTEL_TONIGHT_PLACEMENT",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalRender__WEBPACK_IMPORTED_MODULE_6__/* .Experiment */ .KS, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        m: 3,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HotelsTonight_HotelsTonight__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                m: 3,
                children: extendData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExtendStayV3, _objectSpread({}, extendData, {
                    isMobile: true
                })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CrossSellContent, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                m: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Promos_MarketingTout_MarketingTout__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                m: 3,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalRender__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                        experimentCode: "HP_MBL_HOTEL_TONIGHT_PLACEMENT",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalRender__WEBPACK_IMPORTED_MODULE_6__/* .Original */ .gg, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HotelsTonight_HotelsTonight__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        textAlign: "center",
                        mt: 4,
                        width: 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "div-gpt-ad-1544641976893-0"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_EmailSignUp__WEBPACK_IMPORTED_MODULE_13__/* .EmailSignUpToast */ .Zz, {
                sourceId: "LANDING_HOME_TOAST_MWEB",
                isMobile: true
            })
        ]
    });
};


/***/ })

}]);